'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _pure = require('recompose/pure');

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = require('material-ui/SvgIcon');

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SvgIconCustom = global.__MUI_SvgIcon__ || _SvgIcon2.default;

var _ref = _react2.default.createElement('path', { d: 'M5 16h3v3h2v-5H5v2zm3-8H5v2h5V5H8v3zm6 11h2v-3h3v-2h-5v5zm2-11V5h-2v5h5V8h-3z' });

var FullscreenExit = function FullscreenExit(props) {
  return _react2.default.createElement(
    SvgIconCustom,
    props,
    _ref
  );
};

FullscreenExit = (0, _pure2.default)(FullscreenExit);
FullscreenExit.muiName = 'SvgIcon';

exports.default = FullscreenExit;


//////////////////
// WEBPACK FOOTER
// ./~/material-ui-icons/FullscreenExit.js
// module id = 2454
// module chunks = 0